import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'error-alert-component',
  templateUrl: './error-alert.component.html',
  styleUrl: './error-alert.component.css',
  imports: [MatSnackBarLabel],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorAlertComponent {
  private snackBarRef = inject(MatSnackBarRef<ErrorAlertComponent>);
  public data = inject<string>(MAT_SNACK_BAR_DATA);

  closeSnackBar() {
    this.snackBarRef.dismiss();
  }
}
